// --- 疗养信息 --- //

export default [
  {
    name: 'convalescenceInfo',
    path: '/convalescenceSystem/convalescenceInfo',
    meta: { title: '疗养信息' },
    component: require('business/convalescenceSystem/convalescenceInfo/list.vue').default
  },
  {
    name: 'convalescenceAdd',
    path: '/convalescenceSystem/convalescenceInfo/add',
    meta: { title: '信息发布' },
    component: require('business/convalescenceSystem/convalescenceInfo/add.vue').default
  },
  {
    name: 'convalescenceDetail',
    path: '/convalescenceSystem/convalescenceInfo/detail',
    meta: { title: '公告信息详情' },
    component: require('business/convalescenceSystem/convalescenceInfo/detail.vue').default
  }

]
